import * as React from 'react';
import {
	DataTableCell,
} from '@salesforce/design-system-react';
import { Request } from 'lib/types';

const PriorityGauge: React.SFC<{item?: Request}> = ({ children, ...props }) => {
	const item = props.item ? props.item : {} as Request;
	return (
		<DataTableCell {...props}>
			<img src={`/assets/icons/gauges/${item.priority.toLowerCase()}.svg`} />
			{children}
		</DataTableCell>
	);
};
PriorityGauge.displayName = DataTableCell.displayName;

export default PriorityGauge;


// WEBPACK FOOTER //
// ./src/DataStewardship/priority-gauge.tsx